<template>
  <button type="button" class="btn btn-light" @click="show = true">Add Flight</button>
  <div class="modal" tabindex="-1" :class="show ? 'fade show' : ''" v-show="show">
      <div class="modal-dialog">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title">Add Flight</h5>
            <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close" @click="show = false"></button>
          </div>
          <div class="modal-body">
            <div class="existing-flight mb-3">
              <label for="">Existing Flight</label>
              <select class="form-select" v-model="order_flight.existing_flight" @change="presetFlight(this.value)">
                <option :value="null"></option>
                <option v-for="flight in flights" :key="flight.id" :value="flight.id">
                  {{ findAirport(flight.from)[0].name }} > {{ findAirport(flight.to)[0].name  }} | {{ flight.flight_number }} | {{ $filters.formatDate(flight.departure) }}
                </option>
              </select>
            </div>
            <div class="flight-data">
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="">From</label>
                    <select class="form-select" v-model="order_flight.from">
                      <option :value="null"></option>
                      <option v-for="airport in airports" :key="airport.id" :value="airport.id">
                        [{{ airport.code }}] {{ airport.name }}
                      </option>
                    </select>
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="">To</label>
                    <select class="form-select" v-model="order_flight.to">
                      <option :value="null"></option>
                      <option v-for="airport in airports" :key="airport.id" :value="airport.id">
                        [{{ airport.code }}] {{ airport.name }}
                      </option>
                    </select>
                  </div>
                </div>
              </div>

              <div class="mb-3">
                <label for="">Departure</label>
                <input type="datetime-local" class="form-control" v-model="order_flight.departure">
              </div>
              <div class="row">
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="">Quantity</label>
                    <input type="number" class="form-control" v-model="order_flight.qty">
                  </div>
                </div>
                <div class="col-md-6">
                  <div class="mb-3">
                    <label for="">Price</label>
                    <div class="input-group">
                      <span class="input-group-text" id="basic-addon1">$</span>
                      <input type="number" class="form-control" v-model="order_flight.price">
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="modal-footer">
            <button type="button" class="btn btn-outline-danger" data-bs-dismiss="modal" @click="show = false">Close</button>
            <button type="button" class="btn btn-primary" @click="addFlightToOrder()">Add to order</button>
          </div>
        </div>
      </div>
  </div>
  <div class="modal-backdrop fade show" v-show="show"></div>
</template>

<script>
export default {
  name: 'FlightModal',
  props: ['flights', 'order', 'airports', 'airlines'],
  data() {
    return {
      show: false,
      order_flight: {
        existing_flight: null,
        from: null,
        to: null,
        departure: null,
        qty: null,
        price: null,
      },
    }
  },
  methods: {
    findAirport(airportId) {
      return this.airports.filter(function(item){
          if(item.id == airportId) return item;
      })
    },
    findAirline(airlineId) {
      return this.airlines.filter(function(item){
          if(item.id == airlineId) return item;
      })
    },
    presetFlight(value) {
      console.log(this.flights[0]);
      let flight = this.flights.find(x => x.id === this.order_flight.existing_flight)

      this.order_flight.from = flight.from
      this.order_flight.to = flight.to
      this.order_flight.departure = this.$filters.formatDate(flight.departure)
      this.order_flight.qty
      this.order_flight.price
    },
    addFlightToOrder() {
      let existing = this.order_flight.existing_flight
      let from = this.order_flight.from
      let to = this.order_flight.to
      let departure = this.order_flight.departure
      let qty = this.order_flight.qty
      let price = this.order_flight.price

      this.order.order_lines.push({
        type: 'flight',
        data: {
          existing: existing,
          from: from,
          to: to,
          departure: departure
        },
        name: `Flight: ${ this.findAirport(from)[0].name } - ${ this.findAirport(to)[0].name } | Departure: ${this.$filters.formatDate(departure)}`,
        price: price,
        qty: qty,
      })

      this.show = false;

      this.order_flight.existing_flight = null;
      this.order_flight.from = null;
      this.order_flight.to = null;
      this.order_flight.departure = null;
      this.order_flight.qty = null;
      this.order_flight.price = null;
    }
  }
}
</script>

<style>

</style>
